import { inject, Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { Observable, ReplaySubject, delay, take } from 'rxjs';
import { DsSnackbarComponent } from './snackbar.component';
import {
  DsSnackbarData,
  DsSnackbarOptions,
  DsSnackbarQueueItem,
  DsSnackbarType,
} from './snackbar.models';

@Injectable({
  providedIn: 'root',
})
export class DsSnackbarService {
  private _snackbarQueue: DsSnackbarQueueItem[] = [];

  private readonly _snackBar = inject(MatSnackBar);

  queue(
    message: string,
    options?: DsSnackbarOptions,
  ): Observable<MatSnackBarRef<DsSnackbarComponent>> {
    const ref$ = new ReplaySubject<MatSnackBarRef<DsSnackbarComponent>>();
    this._snackbarQueue.push({
      message: message,
      options: options || {},
      ref$: ref$,
    });

    if (this._snackbarQueue.length === 1) {
      this._openNext();
    }

    return ref$.asObservable();
  }

  private _openNext() {
    const snackbarData: DsSnackbarData = {
      message: this._snackbarQueue[0].message,
      type: this._snackbarQueue[0].options.type || DsSnackbarType.Info,
      action: this._snackbarQueue[0].options.action,
      ref$: this._snackbarQueue[0].ref$,
      href: this._snackbarQueue[0].options.href,
    };

    const snackbarRef = this._snackBar.openFromComponent(DsSnackbarComponent, {
      duration:
        this._snackbarQueue[0].options.duration ||
        (this._snackbarQueue[0].options.action ? 8000 : 4000),
      horizontalPosition: 'start',
      panelClass: 'snackbar-with-component',
      data: snackbarData,
    });

    snackbarRef
      .afterDismissed()
      .pipe(take(1), delay(400))
      .subscribe(() => {
        this._snackbarQueue.shift();
        if (this._snackbarQueue.length > 0) {
          this._openNext();
        }
      });

    this._snackbarQueue[0].ref$.next(snackbarRef);
  }
}
